var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranchGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;opacity:0;}.b{fill:#00c851;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(333 306)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(321.355 308.451)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.156,17.979H30.68V.56a.56.56,0,0,0-.56-.56H17.311a.56.56,0,0,0-.56.56V17.979H15.276a.56.56,0,1,0,0,1.119H32.156a.56.56,0,1,0,0-1.119Zm-10.348,0V14.164h3.814v3.814Zm4.933,0V13.6a.56.56,0,0,0-.56-.56H21.249a.56.56,0,0,0-.56.56v4.374H17.871V1.119H29.561v16.86Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M138.541,66.309H135.8a.56.56,0,0,0-.56.56V69.61a.56.56,0,0,0,.56.56h2.742a.56.56,0,0,0,.559-.56V66.869A.56.56,0,0,0,138.541,66.309Zm-.559,2.742h-1.623V67.428h1.623Z",
    transform: "translate(-116.028 -63.836)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M276.553,66.309h-2.742a.56.56,0,0,0-.56.56V69.61a.56.56,0,0,0,.56.56h2.742a.56.56,0,0,0,.56-.56V66.869A.56.56,0,0,0,276.553,66.309Zm-.559,2.742h-1.623V67.428h1.623Z",
    transform: "translate(-248.893 -63.836)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M138.541,205.954H135.8a.56.56,0,0,0-.56.559v2.742a.56.56,0,0,0,.56.559h2.742a.559.559,0,0,0,.559-.559v-2.742A.559.559,0,0,0,138.541,205.954Zm-.559,2.742h-1.623v-1.623h1.623Z",
    transform: "translate(-116.028 -198.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M276.553,205.954h-2.742a.56.56,0,0,0-.56.559v2.742a.56.56,0,0,0,.56.559h2.742a.56.56,0,0,0,.56-.559v-2.742A.56.56,0,0,0,276.553,205.954Zm-.559,2.742h-1.623v-1.623h1.623Z",
    transform: "translate(-248.893 -198.272)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchGreen);
export default __webpack_public_path__ + "static/media/branchGreen.cdd1943989eba567519c996c93a38566.svg";
export { ForwardRef as ReactComponent };